<template>
    <section class="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-background">
        <div
            v-if="content.bg_image"
            class="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-[0.12]"
            :style="{ backgroundImage: `url(${content.bg_image})`, filter: 'grayscale(100%)' }"
        />

        <div
            class="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-accent/5 blur-3xl -translate-y-1/2 translate-x-1/3"
        />
        <div
            class="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-primary/5 blur-3xl translate-y-1/2 -translate-x-1/3"
        />

        <div class="relative z-10 container mx-auto px-4 pt-24 pb-16 text-center">
            <div
                v-if="content.badge"
                class="inline-block px-4 py-1.5 rounded-full border border-accent/30 bg-accent/10 text-accent text-sm font-semibold mb-8"
            >
                {{ content.badge }}
            </div>

            <h1
                class="text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground leading-tight max-w-5xl mx-auto mb-6"
            >
                {{ content.title_before }}
                <span v-if="content.title_accent" class="text-gradient-blue block mt-2">
                    {{ content.title_accent }}
                </span>
            </h1>

            <p
                v-if="content.subtitle"
                class="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed"
            >
                {{ content.subtitle }}
            </p>

            <div class="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                    v-if="primary.label"
                    :href="primary.url"
                    class="inline-flex items-center justify-center text-base px-8 py-4 rounded-md font-semibold bg-accent text-accent-foreground hover:bg-accent/90 transition-colors"
                >
                    {{ primary.label }}
                </a>
                <a
                    v-if="secondary.label"
                    :href="secondary.url"
                    class="inline-flex items-center justify-center text-base px-8 py-4 rounded-md font-semibold border border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                >
                    {{ secondary.label }}
                </a>
            </div>

            <div v-if="stats.length" class="mt-16 grid grid-cols-3 gap-6 max-w-2xl mx-auto">
                <div v-for="(stat, i) in stats" :key="i" class="text-center">
                    <div class="text-2xl md:text-3xl font-extrabold text-foreground">{{ stat.value }}</div>
                    <div class="text-sm text-muted-foreground mt-1">{{ stat.label }}</div>
                </div>
            </div>
        </div>

        <div class="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background to-transparent" />
    </section>
</template>

<script>
export default {
    name: "HeroBlock",
    props: { content: { type: Object, default: () => ({}) } },
    computed: {
        primary() {
            return this.content.primary_cta || {};
        },
        secondary() {
            return this.content.secondary_cta || {};
        },
        stats() {
            return this.content.stats || [];
        },
    },
};
</script>
